<template>
    <article class="w-full col-span-2 shadow-card p-8 rounded-medium flex flex-col items-center">
        <IconIntegrations class="w-[65px] h-[65px] mx-auto mb-6" />
        <h1 class="text-lg font-medium mb-2 max-w-[620px]">Free migration services</h1>
        <p class="text-sm font-normal mb-auto max-w-[620px]">Get up to 15 hours of free migration services from your old platform to Keap. </p>
        <footer class="mt-6">
            <p class="text-base">Call <a :href="supportNumber" class="underline">{{ supportNumberDisplay }}</a><br/>to get started.</p>
        </footer>
    </article>
</template>

<script>
import IconIntegrations from '@/../svg/Icon_Integrations.svg?component';
import { SUPPORT_PHONE_NUMBER } from '@/Util/constants.js';

export default {
    components: {
        IconIntegrations
    },
    computed: {
        supportNumber() {
            return `tel:${SUPPORT_PHONE_NUMBER}`;
        },
        supportNumberDisplay() {
            return SUPPORT_PHONE_NUMBER;
        },
    }
};
</script>

<style lang="postcss" scoped>
</style>
